import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Avatar, Box, ButtonBase, Hidden, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import * as actions from 'src/redux/actions';
import { ADMIN_VIEW, USER_VIEW } from '../../../redux/Account/constants';
const useStyles = makeStyles((theme) => ({
    avatar: {
        height: 32,
        width: 32,
        marginRight: theme.spacing(1)
    },
    popover: {
        width: 200
    }
}));
function WorkflowSelector() {
    const classes = useStyles();
    const history = useHistory();
    const ref = useRef(null);
    const dispatch = useDispatch();
    const account = useSelector((state) => (state as any).account);
    const { enqueueSnackbar } = useSnackbar();
    const [isOpen, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleLogout = async () => {
        try {
            handleClose();
            await dispatch(actions.signOut());
            history.push('/');
        }
        catch (error) {
            enqueueSnackbar('Unable to logout', {
                variant: 'error'
            });
        }
    };
    const handleSetView = (view: any) => {
        handleClose();
        dispatch(actions.setView(view));
    };
    return (<>
      <Box
          display="flex"
          alignItems="center"
          component={ButtonBase}
          onClick={handleOpen}
          // @ts-ignore - ref
          ref={ref}
      >
        <Avatar alt="User" className={classes.avatar} src={account.user.avatarUrl}/>
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {`${account.user.firstName} ${account.user.lastName}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu onClose={handleClose} anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
    }} keepMounted PaperProps={{ className: classes.popover }} getContentAnchorEl={null} anchorEl={ref.current} open={isOpen}>
        {account.user.isTeamAdmin ? (account.view === USER_VIEW ? (<MenuItem onClick={() => handleSetView(ADMIN_VIEW)}>
                Switch to admin view
              </MenuItem>) : (<MenuItem onClick={() => handleSetView(USER_VIEW)}>
                Switch to user view
              </MenuItem>)) : null}
        <MenuItem onClick={handleLogout}>
          Logout
        </MenuItem>
      </Menu>
    </>);
}
export default WorkflowSelector;
